module.exports = __webpack_public_path__ + "media/images/pic/teachers/wiktoria-piontek-208472e11e0c514fe7584bed9024e1cd.webp";